"use strict";

/**
 * Ansichten-Modul-Konstanten.
 */
gc.gis.module.GCViewsConstants = {
	/**
	 * Standardformat für die Vorschaugrafik.
	 */
	DEF_PREVIEW_FORMAT: 'image/png',
	/**
	 * Standardbreite für die Vorschaugrafik.
	 */
	DEF_PREVIEW_WIDTH: 300,
	/**
	 * Standardhöhe für die Vorschaugrafik.
	 */
	DEF_PREVIEW_HEIGHT: 300
};

/**
 * Ansichten-Modul-Events.
 * @enum {string}
 */
gc.gis.module.GCViewsEvent = {
	/**
	 *
	 */
	VIEW_LOADING_STARTED: 'view:update:start',
	/**
	 *
	 */
	VIEW_LOADING_STOPPED: 'view:update:end',
	/**
	 *
	 */
	VIEW_SELECTED: 'view:select',
	/**
	 *
	 */
	VIEW_SAVED: 'view:save',
	/**
	 *
	 */
	VIEW_LOADED: 'view:load',
	/**
	 *
	 */
	VIEW_DELETED: 'view:delete'
};

/**
 * @enum {string}
 */
gc.gis.module.GCViewsHook = {
	/**
	 * Hook zum erweitern des Config-Objekts beim Speichern einer Ansicht.
	 */
	SAVE_CONFIG: 'views:config:save'
};

/**
 * @classdesc
 * Ansichten-Modul
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.alias
 * @param {string} options.target
 * @param {String} options.requests.viewsGetAllUrl
 * @param {String} options.requests.viewsGetSingleUrl
 * @param {String} options.requests.viewsSetDefaultUrl
 * @param {String} options.requests.viewsUpdateUrl
 * @param {String} options.requests.viewsDeleteUrl
 * @param {gc.gis.map.GCMapView} [options.map=gc.gis.iface.map]
 * @param {string} [options.label='Ansichten']
 */
gc.gis.module.GCViews = function( options )
{
	gc.gis.module.GCAbstractModule.call( this, options );

	this.options       = options;
	this.map           = options.map || gc.gis.iface.map;
	this.label         = options.label || 'Ansichten';
	this.views         = [];
	this.selected_view = undefined;

	this._render();

	this.updateViewList();
};
gc.gis.module.GCViews.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 *
 */
gc.gis.module.GCViews.prototype.getElement = function()
{
	return this._element;
};

/**
 *
 */
gc.gis.module.GCViews.prototype.getListPanel = function()
{
	return this.element_panel_list.getElement();
};

/**
 *
 */
gc.gis.module.GCViews.prototype.getSavePanel = function()
{
	return this.element_panel_save.getElement();
};

/**
 *
 */
gc.gis.module.GCViews.prototype._render = function()
{
	var self = this;

	// Panel-Widgets
	this.element_panel_list = new gc.gis.module.GCViews.ListPanel({
		module: self,
		active: self.active
	});

	this.element_panel_save = new gc.gis.module.GCViews.SavePanel({
		module: self,
		active: self.active
	});

	this.element_panel_preview = new gc.gis.module.GCViews.PreviewPanel({
		module: self,
		active: self.active
	});

	// Sidebar-Content Liste
	this._content_list =  new gc.gis.ui.GCSidebarContent({
        label: this.label,
        'parent': null,
        element: this.element_panel_list.getElement()
    });

	// Launcher
	this.launcher = {
		label: this.label,
		//icon: 'glyphicon glyphicon-film',
		//icon: 'ms ms-map-o',
		icon: 'glyphicon glyphicon-picture',
		content: this._content_list
	};
	gc.gis.iface.ui.sidebar.addLauncher(this.launcher);

	// Sidebar-Content Speichern und Vorschau
	this._content_save = new gc.gis.ui.GCSidebarContent({
		label: 'Ansicht speichern',
		'parent': this._content_list,
		launcher: this.launcher.element,
		element: this.element_panel_save.getElement()
	});
	this._content_preview = new gc.gis.ui.GCSidebarContent({
        label: 'Ansicht / Vorschau',
        'parent': this._content_list,
		launcher: this.launcher.element,
        element: this.element_panel_preview.getElement()
    });

	// Toolbar vom Listen-Panel erweitern
	this.element_panel_list.getToolbar().addItem(new gc.gis.widget.GCItem({
		label: 'Speichern',
		className: 'btn btn-default',
		click: function (evt)
		{
			gc.gis.iface.ui.sidebar.setContent(self._content_save);
		}
	}));

	this.element_panel_list.getElement();
};

/**
 *
 */
gc.gis.module.GCViews.prototype.getViews = function()
{
	return this.views;
};

/**
 *
 */
gc.gis.module.GCViews.prototype.getOwnViews = function()
{
	var all_views = this.getViews();
	var own_views = [];
	for( var i=0; i<all_views.length; i++ )
	{
		if( all_views[i].states && all_views[i].states.own )
		{
			own_views.push( all_views[i] );
		}
	}
	return own_views;
};

/**
 *
 */
gc.gis.module.GCViews.prototype.getViewById = function( id )
{
	var views = this.getViews();
	for( var i=0; i<views.length; i++ )
	{
		if( views[i].id === id )
		{
			return views[i];
		}
	}
	return undefined;
};

/**
 *
 */
gc.gis.module.GCViews.prototype.getSelectedView = function()
{
	return this.selected_view;
};

/**
 *
 */
gc.gis.module.GCViews.prototype.setSelectedView = function( view )
{
	var old = this.selected_view;
	this.selected_view = view;
	this._fireEvent( gc.gis.module.GCViewsEvent.VIEW_SELECTED, {
		oldValue: old,
		newValue: this.selected_view
	});

	if (view)
	{
        gc.gis.iface.ui.sidebar.setContent( this._content_preview );
	}
	else
	{
		gc.gis.iface.ui.sidebar.setContent( this._content_list );
	}
};

/**
 *
 */
gc.gis.module.GCViews.prototype._handleSaveConfigHook = function( config )
{
	var hooks = this.getHooks([gc.gis.module.GCViewsHook.SAVE_CONFIG]) || [];

	for( var i=0; i<hooks.length; i++ )
	{
		try
		{
			(function( hook ) {
				hook.initFunc.call( self, {viewConfig: config} );
			})( hooks[i] );
		}
		catch( err )
		{
			gc.gis.iface.log.error( this, err );
			// gc.gis.iface.log.error( this, new gc.gis.error.GCError('Failed to attach hooked action', err ) );
		}
	}
};

/**
 *	@see gc.gis.Application#setView()
 */
gc.gis.module.GCViews.prototype.saveView = function( view )
{
	gc.gis.assert.isSet(view);
	var self = this;

	if (view)
	{
		this._fireEvent( gc.gis.module.GCViewsEvent.VIEW_LOADING_STARTED, {} );

		try
		{
			var out = {
				name:        view.name,
				description: view.description,
				layers:      view.layers
			};
			if( view.id )
			{
				out.id = view.id;
			}
			if( !view.previewUrl )
			{
				out.previewUpload = this.map.getCanvasDump(
					gc.gis.module.GCViewsConstants.DEF_PREVIEW_FORMAT,
					gc.gis.module.GCViewsConstants.DEF_PREVIEW_WIDTH,
					gc.gis.module.GCViewsConstants.DEF_PREVIEW_HEIGHT
				);
			}
			if( view.viewport )
			{
				out.geometry   = view.viewport.geometry;
				out.rotation   = view.viewport.rotation;
				out.projection = view.viewport.projection;
			}
			if( !view.layers )
			{
				out.layers = this.map.getLayerConfigs();
			}
			if( view.setDefault )
			{
				out.setDefault = true;
			}

			// Ansichten-Config ggf. per Hook erweitern
			this._handleSaveConfigHook( out );

			var url = this.options.requests.viewsUpdateUrl;

			out = JSON.stringify(out);
			gc.gis.iface.request.ajax({
				label: 'Speichere Ansicht "'+ view.name +'" ... ',
				context: this,
				url: url,
				method: 'POST',
				data: out,
				contentType: gc.gis.util.GCRequestManagerContentType.JSON,
				success: function( data ) {
					var results = JSON.parse( data ).results;
                    if( results.success )
                    {
						gc.gis.iface.log.info(self, 'Ansicht "' + view.name + '" wurde gespeichert.');
                        self.updateViewList();
                        gc.gis.iface.ui.sidebar.setContent( self._content_list );
                    }
                    else
					{
						throw new gc.gis.error.GCError('Ansicht "' + view.name + '" konnte nicht gespeichert werden.');
					}
                },
                finally: function() {
					self._fireEvent(gc.gis.module.GCViewsEvent.VIEW_SAVED, {});
                    self._fireEvent( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, {} );
				},
				error: function( err ) {
					self._fireEvent( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, {} );
				}
			});
		}
		catch( err )
		{
			gc.gis.iface.log.error( self, err );
			self._fireEvent( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, {} );
		}
	}
	else
	{
		gc.gis.iface.log.warn(this, 'Leere Ansicht wird nicht gespeichert.');
	}
};

/**
 *
 */
gc.gis.module.GCViews.prototype.updateViewList = function()
{
	var self = this;

	this._fireEvent( gc.gis.module.GCViewsEvent.VIEW_LOADING_STARTED, {} );

	gc.gis.iface.request.ajax({
		label: 'Lade verfügbare Ansichten ... ',
		context: this,
		url: this.options.requests.viewsGetAllUrl,
		success: function(data) {
            self.views = JSON.parse(data).results;
		},
		finally: function() {
			self._fireEvent( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, {} );
		}
	});
};

/**
 *
 */
gc.gis.module.GCViews.prototype.setDefaultView = function( view )
{
	gc.gis.assert.isSet(view);
	const self = this;

	if (view) {
		this._fireEvent(gc.gis.module.GCViewsEvent.VIEW_LOADING_STARTED, {});

		gc.gis.iface.request.ajax({
			label: 'Setze Startansicht ... ',
			context: this,
			url: gc.gis.GCUrl.buildUrl(this.options.requests.viewsSetDefaultUrl, {'id': view.id}),
			success: function (data) {
				var results = JSON.parse(data).results;
				if (results.success) {
					if (!(view.states && view.states.default)) {
						gc.gis.iface.log.info(self, '"' + view.name + '" ist jetzt die eigene Startansicht.');
					}
					else {
						gc.gis.iface.log.info(self, '"' + view.name + '" ist jetzt nicht mehr die eigene Startansicht.');
					}
					self.updateViewList();
					gc.gis.iface.ui.sidebar.setContent(self._content_list);
				}
				else {
					throw new gc.gis.error.GCError('Fehler beim Setzen der Startansicht.');
				}
			},
			finally: function () {
				self._fireEvent(gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, {});
			}
		});
	}
	else
	{
		gc.gis.iface.log.warn(this, 'Keine Ansicht ausgewählt.');
	}


};

/**
 *
 */
gc.gis.module.GCViews.prototype.deleteView = function(view)
{
	gc.gis.assert.isSet(view);
	const self = this;

	if (view)
	{
		if (view.states && view.states.readwrite)
		{
			this._fireEvent(gc.gis.module.GCViewsEvent.VIEW_LOADING_STARTED, {});

			gc.gis.iface.request.ajax({
				label: 'Lösche Ansicht "' + view.name + '" ... ',
				context: this,
				url: gc.gis.GCUrl.buildUrl(this.options.requests.viewsDeleteUrl, {'id': view.id}),
				success: function (data) {
					const results = JSON.parse(data).results;
					if (results.success) {
						gc.gis.iface.log.info(self, '"' + view.name + '" wurde entfernt.');
						self.updateViewList();
						gc.gis.iface.ui.sidebar.setContent(self._content_list);
					}
					else {
						throw new gc.gis.error.GCError('Fehler beim Löschen der Ansicht.');
					}
				},
				finally: function () {
					self._fireEvent(gc.gis.module.GCViewsEvent.VIEW_DELETED, {});
					self._fireEvent(gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, {});
				}
			});
		}
	}
	else {
		gc.gis.iface.log.warn(this, 'Keine Ansicht ausgewählt.');
	}
};
